import classNames from "classnames";
import LinkedinLogo from "../../../images/linkedin-logo.svg?react";
import AuthButton from "../AuthButton";

interface Props {
  children: React.ReactNode;
  className?: string;
  onClick: () => void;
}

export default function LinkedinButton({ children, className, onClick }: Props) {
  return (
    <AuthButton
      buttonClass={classNames("linkedin-button", className)}
      imageClass="linkedin-logo"
      textClass="linkedin-text"
      logo={LinkedinLogo}
      onClick={onClick}
    >
      {children}
    </AuthButton>
  );
}
